import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { PermissionCheckAddCommentQuery } from './PermissionCheckAddCommentQuery.graphql';

export function preloadAddCommentPermissionCheck(contentId: string) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: PermissionCheckAddCommentQuery,
		variables: {
			contentId,
		},
	});
}
